import { FC } from 'react';
import styles from './hiddenText.module.scss';

const HiddenText: FC<hiddenTextProps> = (props: hiddenTextProps) => {
    const { isHidden, text, hiddenLength = 10 } = props;

    if (isHidden) {
        return <div className={styles.wrapper}>{`${'*'.repeat(hiddenLength)}`}</div>;
    }

    return <div className={styles.wrapper}>{text}</div>;
};

interface hiddenTextProps {
    isHidden: boolean;
    text: string;
    hiddenLength?: number;
}

export default HiddenText;
